import React, { useState, useContext } from 'react';
import * as Cookies from '../Base/Cookies';
import { CookieContext } from '../Context/cookies';

const COOKIE_NAME = 'showSensitiveImages';
export default (WrappedComponent) => {
  const SensitiveImage = (props) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleShowSensitiveImages = (cookieContext) => {
      if (cookieContext.isAllowed('ShowSensitiveImagesCookie')) {
        Cookies.eraseCookie(COOKIE_NAME);
        Cookies.createCookie(COOKIE_NAME, 'true');
      }

      setIsLoading(true);

      setTimeout(() => {
        location.reload();
      }, 1200);
    };

    const cookieContext = useContext(CookieContext);

    const cookieData = props.CurrentPageProps.cookies;
    const hideSensitiveImage =
      Cookies.parseCookieData(COOKIE_NAME, cookieData) === 'false' &&
      props.IsSensitiveInContext &&
      props.CurrentPageProps.IsEditMode === false;

    return (
      <WrappedComponent
        {...props}
        hideSensitiveImage={hideSensitiveImage}
        handleShowSensitiveImages={() =>
          handleShowSensitiveImages(cookieContext)
        }
        showSensitiveImageIsLoading={isLoading}
      />
    );
  };

  return SensitiveImage;
};
